import { render, staticRenderFns } from "./Radios.vue?vue&type=template&id=3d873820&scoped=true"
import script from "./Radios.vue?vue&type=script&lang=js"
export * from "./Radios.vue?vue&type=script&lang=js"
import style0 from "./Radios.vue?vue&type=style&index=0&id=3d873820&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d873820",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3d873820')) {
      api.createRecord('3d873820', component.options)
    } else {
      api.reload('3d873820', component.options)
    }
    module.hot.accept("./Radios.vue?vue&type=template&id=3d873820&scoped=true", function () {
      api.rerender('3d873820', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/common/rubric/form/components/questionTypes/Radios.vue"
export default component.exports